import { PlusIcon } from "@heroicons/react/24/outline";

type Props = {
	label: string;
	onClick: () => void;
};

export function AddPillButton({ label, onClick }: Props) {
	return (
		<button type="button"
				aria-label={label}
				className="flex h-7 w-12 items-center justify-center rounded-full bg-primary-500 text-white hover:bg-primary-700"
				onClick={onClick}>
			<PlusIcon aria-hidden className="size-4" />
		</button>
	);
}
